/** @format */
import {MultilineChartInterface} from 'components/charts/multiline-chart/model/common';

import {TooltipDataList} from 'components/charts/multiline-chart/model/tooltip';

import {Discreteness} from 'components/PeriodSelector/model';

import {ChartIds} from '../../models/chartIds';
import {WIDGETS_LIST} from '../../constants/widgets';
import mapTooltipPoint from './mapTooltipPoint';

import {SensorsList} from '../../helpers/sensors/types';
import {DateList} from '../../models/common';

interface Options {
  multiChartData: MultilineChartInterface<ChartIds>;
  discreteness?: Discreteness;
  dateList: DateList;
  yesterday?: string;
  sensors?: SensorsList;
  startDate: string;
}

const addTooltips = ({
  multiChartData,
  discreteness,
  sensors,
  startDate,
  yesterday,
  dateList,
}: Options): MultilineChartInterface<ChartIds> => {
  const tooltips: TooltipDataList<ChartIds> = {};
  const pointNamesList = Object.keys(dateList);
  const isDiscreteness = discreteness === 'week' || discreteness === 'month';

  pointNamesList.forEach((pointName, index) => {
    const date = dateList[pointName];

    for (let i = 0; i < multiChartData.charts.length; i++) {
      const chart = multiChartData.charts[i];
      const chartId = chart.chartId;
      const widget = WIDGETS_LIST[chartId];

      if (widget?.skipTooltip) {
        continue;
      }

      const chartData = chart.chartsData[index];

      if (!chartData) {
        continue;
      }

      // Если нужно вычислить дельту, то забираем предыдущие данные

      const needDelta = isDiscreteness && widget.isTooltipDelta;
      const previousChartData = needDelta && index > 0 ? chart.chartsData[index - 1] : undefined;
      const prevPointName = index > 0 ? pointNamesList[index - 1] : undefined;
      const previousDate =
        needDelta && index > 0 && prevPointName ? dateList[prevPointName] : undefined;

      const tooltip = mapTooltipPoint({
        chartId,
        date,
        previousDate,
        yesterday,
        chartData,
        previousChartData,
        sensors,
        widget,
        startDate,
        isDiscreteness,
      });

      if (tooltips[pointName] && tooltip.rows) {
        tooltips[pointName].rows?.push(...tooltip.rows);
      } else {
        tooltips[pointName] = tooltip;
      }
    }
  });

  return {
    ...multiChartData,
    tooltipDataList: tooltips,
  };
};

export {addTooltips};
